import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import callApi from "src/services/Common/api";
import { downloadPDFFromBase64 } from "src/services/Common/FileUtils";

export default function AgencyAdmitCard() {
  const [loading, setLoading] = useState(false);
  const [rollNumber, setRollNumber] = useState("");
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    const value = e.target.value;
    setRollNumber(value);
    // Clear error when user starts typing
    if (error) setError("");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      download();
    }
  };

  const validateInput = () => {
    if (!rollNumber.trim()) {
      setError("Please enter a roll number");
      return false;
    }
    return true;
  };

  const download = async () => {
    if (!validateInput()) return;

    setLoading(true);
    setError("");

    try {
      const responseData = await callApi(
        `/v1/api/admit-cards/cand-admit-card/${rollNumber.trim()}`,
        "GET",
        null,
        true,
        null
      );

      if (responseData.success !== false) {
        downloadPDFFromBase64(
          responseData.body.base64,
          responseData.body.fileName
        );
        setRollNumber("");
      } else {
        setError("Admit card not found or failed to download");
      }
    } catch (err) {
      setError("Failed to download admit card. Please try again.");
      console.error("Download error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="card mt-3">
        <div
          className="card-header text-white"
          style={{ backgroundColor: "#3C4B64" }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <span className="mr-auto">Download Admit Card</span>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <div className="mb-3">
                <label htmlFor="rollNumber" className="form-label">
                  Roll Number
                </label>
                <input
                  id="rollNumber"
                  type="text"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  placeholder="Enter Roll Number"
                  value={rollNumber}
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  disabled={loading}
                />
                {error && <div className="invalid-feedback">{error}</div>}
              </div>
              <div className="mb-3">
                <button
                  className="btn btn-success text-white"
                  onClick={download}
                  disabled={loading || !rollNumber.trim()}
                >
                  {loading ? (
                    <>
                      <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                      Downloading...
                    </>
                  ) : (
                    "Download Admit Card"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
